import {
    Component,
    h,
    Host,
    Prop,
} from '@stencil/core';
import { ThemeType } from '@uipath/portal-shell-util';

import store from '../../store/store';
import { getInitials } from '../../utils/initialHelper';
import { sessionStore } from '../../utils/session/sessionStore';
import { getTheme } from '../../utils/themeHelper';

@Component({
    tag: 'portal-avatar',
    styleUrl: 'portal-avatar.scss',
})
export class PortalAvatar {
    /**
     * Theme override to bypass store state
     * @memberof PortalAvatar
     */
    @Prop() theme: ThemeType = 'autoTheme';

    /**
     * Size of avatar as a string, ex. `"20px"`
     * @memberof PortalAvatar
     */
    @Prop() size: string = '28px';

    /**
     * The src URL of the avatar image
     * @memberof PortalAvatar
     */
    @Prop() imageUrl?: string;

    /**
     * The full name of the user
     * @memberof PortalAvatar
     */
    @Prop() fullName?: string;

    /**
     * If the avatar is a button
     * @memberof PortalAvatar
     */
    @Prop() isButton?: boolean = true;

    render() {
        const imgUrl = this.imageUrl ?? sessionStore.get('avatarUrl');
        const fullName = this.fullName ?? sessionStore.get('fullName');
        const avatarStyle = {
            width: this.size,
            height: this.size,
            minHeight: this.size,
        };

        return (
            <Host class={getTheme(store, this.theme)}>
                <div
                    id={this.isButton ? 'portal-avatar-button' : 'portal-avatar'}
                    data-test="profile"
                    data-cy='nav-tile-profile'
                    title={fullName}
                    class={`pt-profile-root${this.isButton ? ' button' : ''}`}
                    aria-haspopup={this.isButton ? 'true' : undefined}
                    aria-label={fullName}>
                    {
                        imgUrl
                            ? <img
                                role='presentation'
                                class='pt-circ'
                                style={avatarStyle}
                                data-test="profile-img"
                                src={imgUrl}
                                alt={getInitials(fullName)} />
                            : <div
                                role='presentation'
                                class='pt-circ'
                                style={avatarStyle}
                                data-test="profile-initial"
                                innerHTML={getInitials(fullName)} />
                    }
                </div>
            </Host>
        );
    }
}
